import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ofType } from '@ngrx/effects';

@Component({
  selector: 'app-notas-ingreso',
  templateUrl: './notas-ingreso.component.html',
  styleUrls: ['./notas-ingreso.component.scss']
})
export class NotasIngresoComponent implements OnInit {

  public notasIngresoAP: string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos) { 
    if(this.datos == null){
      this.notasIngresoAP = "Sin Notas de Ingreso";
    }else{
      this.notasIngresoAP = this.datos;
    }
  }

  ngOnInit() {
  }

}
